import React from "react";
import { Modal } from "react-bootstrap";
import { RiCloseLargeFill } from "react-icons/ri";
import { FiTrash2, FiPlay, FiSquare, FiAlertTriangle } from "react-icons/fi";

/**
 * One confirmation dialog for the three destructive-ish game actions.
 * `tone` picks the icon and the confirm button colour so start, stop and
 * delete never look like the same click.
 */
const TONES = {
  danger: { Icon: FiTrash2, btn: "btn-danger", ring: "cam-ring-danger" },
  warning: { Icon: FiSquare, btn: "btn-warning", ring: "cam-ring-warning" },
  success: { Icon: FiPlay, btn: "btn-success", ring: "cam-ring-success" },
};

export default function ConfirmActionModal({
  show,
  onClose,
  onConfirm,
  tone = "danger",
  title = "Are you sure?",
  message = "",
  detail = "",
  confirmText = "Confirm",
  busyText = "Working...",
  cancelText = "Cancel",
  loading = false,
}) {
  const { Icon, btn, ring } = TONES[tone] || TONES.danger;

  return (
    <Modal show={show} onHide={onClose} centered backdrop="static" keyboard={!loading}>
      <div className="modal-header border-0 pb-0">
        <h5 className="modal-title">{title}</h5>
        <button className="btn" onClick={onClose} disabled={loading} aria-label="Close">
          <RiCloseLargeFill size={20} />
        </button>
      </div>
      <hr className="my-1" />

      <Modal.Body className="text-center pt-2">
        <div className={`cam-icon ${ring}`}>
          <Icon size={30} />
        </div>
        <p className="cam-message">{message}</p>
        {detail ? (
          <p className="cam-detail">
            <FiAlertTriangle size={13} /> {detail}
          </p>
        ) : null}
      </Modal.Body>

      <div className="modal-footer border-0 justify-content-center">
        <button className="btn btn-light px-4" onClick={onClose} disabled={loading}>
          {cancelText}
        </button>
        <button className={`btn ${btn} px-4`} onClick={onConfirm} disabled={loading}>
          {loading ? busyText : confirmText}
        </button>
      </div>
    </Modal>
  );
}
